import request from '@/utils/request'
// 查询商品
export function getProductAllList (params) {
  return request({
    url: '/product/list',
    method: 'get',
    params: params
  })
}
export function getSupplyProductList (params) {
  return request({
    url: '/product/supplyList',
    method: 'get',
    params: params
  })
}

// 根据商品名称或货号模糊查询
export function getProductList (params) {
  return request({
    url: '/product/simpleList',
    method: 'get',
    params: params
  })
}
// 查询商品驳回数量
export function backCount (params) {
  return request({
    url: '/product/backCount',
    method: 'get',
    params: params
  })
}
// 批量修改删除状态
export function deleteProduct (data) {
  return request({
    url: '/product/update/deleteStatus?ids=' + data.ids + '&deleteStatus=' + data.deleteStatus,
    method: 'post',
    data: data
  })
}

// 批量上下架 上架状态：0->下架；1->上架
export function updatePublishStatus (data) {
  return request({
    url: '/product/update/publishStatus?ids=' + data.ids + '&publishStatus=' + data.publishStatus,
    method: 'post',
    data: data
  })
}
// 复制商品
export function getCopyProduct (data) {
  return request({
    url: '/product/saveCopyProduct?productId=' + data.productId,
    method: 'post',
    data: data
  })
}
// 批量移动商品到新分类
export function updateProductCategory (data) {
  return request({
    url: '/product/updateMoveProduct?productIds=' + data.productIds + '&categoryIdI=' + data.categoryIdI + '&categoryIdIi=' + data.categoryIdIi + '&categoryIdIii=' + data.categoryIdIii,
    method: 'post',
    data: data
  })
}

// 批量修改审核状态
export function updateVerifyStatus (data) {
  return request({
    url: '/product/update/verifyStatus?ids=' + data.ids + '&verifyStatus=' + data.verifyStatus + '&detail=' + data.detail,
    method: 'post',
    data: data
  })
}
// 获取商家所有子标签
export function getProductSubLableList (data) {
  return request({
    url: '/label/getProductSubLableList?mchtId=' + data.mchtId + '&pageNum=' + data.pageNum + '&pageSize=' + data.pageSize,
    method: 'post',
    data: data
  })
}

// 批量修改商品标签
export function updateProductLabel (data) {
  return request({
    url: '/product/updateProductLabel',
    method: 'post',
    data: data
  })
}

// 删除
export function fetchList (params) {
  return request({
    url: '/product/list',
    method: 'get',
    params: params
  })
}

export function fetchSimpleList (params) {
  return request({
    url: '/product/simpleList',
    method: 'get',
    params: params
  })
}

export function updateDeleteStatus (params) {
  return request({
    url: '/product/update/deleteStatus',
    method: 'post',
    params: params
  })
}

export function updateNewStatus (params) {
  return request({
    url: '/product/update/newStatus',
    method: 'post',
    params: params
  })
}

export function updateRecommendStatus (params) {
  return request({
    url: '/product/update/recommendStatus',
    method: 'post',
    params: params
  })
}
//
// export function updatePublishStatus(params) {
//   return request({
//     url:'/product/update/publishStatus',
//     method:'post',
//     params:params
//   })
// }

export function createProduct (data) {
  return request({
    url: '/product/create',
    method: 'post',
    data: data
  })
}

export function updateProduct (id, data) {
  return request({
    url: '/product/update/' + id,
    method: 'post',
    data: data
  })
}

export function getProduct (id) {
  return request({
    url: '/product/updateInfo/' + id,
    method: 'get',
  })
}
// 获取商品的关联商品
export function productRecommendList (params) {
  return request({
    url: '/recommend/productRecommendList',
    method: 'post',
    params: params
  })
}
// 导入商品列表
export function importGoodsList (params) {
  return request({
    url: '/product/data/insertUrlList',
    method: 'post',
    params
  })
}
// 导入单个商品
export function importGoods (params) {
  return request({
    url: '/product/data/insertUrl',
    method: 'post',
    params
  })
}
// 刷新商品功能,刷新完变成新品上架
export function updateLabelStatus (params) {
  return request({
    url: '/product/updateLabelStatus',
    method: 'post',
    params: params
  })
}

export function shopSupplyAudit (params) {
  return request({
    url: '/mcht/supply/shopAudit',
    method: 'get',
    params: params
  })
}

export function applyShopAudit (params) {
  return request({
    url: '/mcht/supply/applyShopAudit',
    method: 'get',
    params: params
  })
}

export function supplyList (params) {
  return request({
    url: '/mcht/supply/supplyList',
    method: 'get',
    params: params
  })
}
export function applySupplyGood (data) {
  return request({
    url: '/mcht/supply/applyGood',
    method: 'post',
    data: data
  })
}

export function supplyUpdateStatus (params) {
  return request({
    url: '/mcht/supply/update/deleteStatus',
    method: 'post',
    params: params
  })
}

export function updatePrice (params) {
  return request({
    url: '/mcht/supply/updatePrice',
    method: 'post',
    params: params
  })
}

export function getSupplierCategory (params) {
  return request({
    url: '/mcht/supply/getSupplierCategory',
    method: 'get',
    params: params
  })
}

export function brandList (params) {
  return request({
    url: '/mcht/supply/brandList',
    method: 'get',
    params: params
  })
}

export function getCategoryProperty (params) {
  return request({
    url: '/mcht/supply/getCategoryProperty',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js